module.exports = __webpack_public_path__ + "static/media/Chesnaught_gaussian2.5758d1c0.png";